<div class="card student-tree" *ngIf="guardian">

  <h6 class="card-header">Students at a glance</h6>
  <div class="card-body">
  <ul >

  <li *ngIf="guardian.students.length>2">
      <button
          class="btn btn-outline-primary"
          (click)="addStudentRegistrationPopup()" >
          <i class='fa fa-plus'></i> Register New Student
      </button> <hr/>
  </li>


  <li *ngFor="let student of guardian.students; index as myCount">
      <span *ngIf="is_admin">
        <a [routerLink]="['/admin/student/manage',student.server_user_id]">
          <i class="fa fa-graduation-cap text-secondary"></i> {{student.fullname}}
        </a></span>
      <span *ngIf="!is_admin"><i class="fa fa-graduation-cap text-secondary"></i> {{student.fullname}}</span>
      <ul [ngClass]="{'background-primary':target_student_user_id==student.server_user_id}">
          <li *ngIf="student.bs.length>0">
            <a [routerLink]="['/student/show',student.server_user_id]" >
            <i class="fa fa-thumbs-up text-secondary"></i> Quiz ({{student.level_short_name}})
            </a>
          </li>
          <li *ngIf="student.bs.length==0">
            <a [routerLink]="['/student/enrollments',student.server_user_id]" class="btn btn-outline-primary">
              <i class='fa fa-plus'></i> Enrol to Class</a>
          </li>
          <li  *ngIf="student.bs.length>0">
              <a [routerLink]="['/student/enrollments',student.server_user_id]">
                  <i class="fa fa-chevron-right text-secondary"></i> Enrollments (View, Add)
              </a>
          </li>
      </ul>
  </li>

  <hr/>
  <li >
      <button
          class="btn btn-outline-primary"
          (click)="addStudentRegistrationPopup()" >
          <i class='fa fa-plus'></i> Register New Student
      </button> <hr/>
  </li>
  </ul>
  </div>
</div>
<app-register-student [guardian]="guardian" *ngIf="guardian"
(closeModalRequest)="closeModal($event)" (notificationRegFinished)="reloadMainHomePage($event)"></app-register-student>
